<script setup lang="ts">
import ApplicationScoreService from '@/core/conversations/application-score/application-score.service';
import XCloseIcon from '@/assets/svg/conversations/XCloseIcon.svg?component';

const props = defineProps<{
  jobId: number;
}>();

const applicationScoreService = new ApplicationScoreService();

const handleClose = () => {
  applicationScoreService.dismissFeedbackBanner(props.jobId);
};
</script>

<template>
  <div class="border-purple-200/20 bg-banner relative flex flex-col gap-4 rounded-lg border p-3">
    <div class="flex items-start justify-between">
      <div class="flex items-center gap-2">
        <div class="flex h-6 w-6 items-center justify-center rounded-full bg-copilot-50">
          <img src="@/assets/svg/jobs/copilot-purple-hexagon.svg" class="h-4 w-4" />
        </div>
        <span class="text-purple-600 gradient-bg text-sm font-bold">AI Learning Active</span>
      </div>
      <button
        @click="handleClose"
        class="text-gray-400 hover:text-gray-600 transition-colors"
        aria-label="Close"
      >
        <XCloseIcon class="h-4 w-4" />
      </button>
    </div>

    <div class="pr-6">
      <p class="text-sm font-normal text-shade-820">
        Your AI recruiter learned from your feedback and is applying improved evaluation criteria to
        new candidates.
      </p>
    </div>
  </div>
</template>

<style scoped>
.gradient-bg {
  background: linear-gradient(270deg, #ae35f7 -15.75%, #5f30d1 71.06%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.bg-banner {
  border-color: #f4efff;
  background: #f9f5fe;
}
</style>
